// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"AccordionMenu_menuItem__hILss","icon":"AccordionMenu_icon__IbSO6","title":"AccordionMenu_title__hVPbG","subtitle":"AccordionMenu_subtitle__7sDig"};